import { render, staticRenderFns } from "./CompImg.vue?vue&type=template&id=01a4d22b"
import script from "./CompImg.vue?vue&type=script&lang=js"
export * from "./CompImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports